import axios from "axios";
import { BACKEND_URL as RESOLVED_BACKEND_URL } from "./backendBase";

export const BACKEND_URL = RESOLVED_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// ---------- Public (proxied from cemedeiros.com.br) ----------
export const fetchHome = async () => (await api.get("/home")).data;
export const fetchTodayDevotional = async () => (await api.get("/devotionals/today")).data;
export const fetchDevotionals = async () => (await api.get("/devotionals")).data;
export const fetchDevotional = async (id) => (await api.get(`/devotionals/${id}`)).data;
export const fetchTodayVerse = async () => (await api.get("/verse/today")).data;
export const fetchSermons = async (params = {}) => (await api.get("/sermons", { params })).data;
export const fetchSermon = async (id) => (await api.get(`/sermons/${id}`)).data;
export const fetchCategories = async () => (await api.get("/sermons/categories")).data;
export const fetchVideos = async () => (await api.get("/videos")).data;
export const fetchBooks = async () => (await api.get("/books")).data;
export const fetchWhatsapp = async () => (await api.get("/settings/whatsapp")).data;

// ---------- Prayer (local) ----------
export const submitPrayer = async (payload) => (await api.post("/prayer-requests", payload)).data;

// ---------- Reading Plans (local) ----------
export const fetchPlans = async () => (await api.get("/plans")).data;
export const fetchPlan = async (slug) => (await api.get(`/plans/${slug}`)).data;

// ---------- Admin (JWT cookie + role=admin) ----------
// Reading Plans admin
export const adminListPlans = async () => (await api.get("/admin/plans")).data;
export const adminCreatePlan = async (data) => (await api.post("/admin/plans", data)).data;
export const adminUpdatePlan = async (id, data) => (await api.put(`/admin/plans/${id}`, data)).data;
export const adminDeletePlan = async (id) => (await api.delete(`/admin/plans/${id}`)).data;

// Prayer requests admin
export const adminListPrayers = async () => (await api.get("/admin/prayer-requests")).data;
export const adminUpdatePrayerStatus = async (id, status) =>
  (await api.patch(`/admin/prayer-requests/${id}`, { status })).data;
export const adminDeletePrayer = async (id) =>
  (await api.delete(`/admin/prayer-requests/${id}`)).data;

// Settings admin
export const adminListSettings = async () => (await api.get("/admin/settings")).data;
export const adminUpdateSetting = async (key, value) =>
  (await api.put(`/admin/settings/${key}`, { value })).data;

// Cache purge (admin)
export const adminPurgeCache = async () => (await api.post("/admin/cache/purge", {})).data;
